import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  useTheme,
  Container,
  Chip,
  Stack,
  Paper,
} from "@mui/material";
import {
  Verified as VerifiedIcon,
  Security as SecurityIcon,
  SupportAgent as SupportAgentIcon,
} from "@mui/icons-material";

export default function GymPolicy() {
  const theme = useTheme();

  // Partnership criteria data
  const partnershipCriteria = [
    {
      _id: 1,
      title: "تایید اصالت و مجوز",
      description:
        "باشگاه‌ها باید دارای مجوز رسمی از وزارت ورزش و جواز کسب معتبر باشند",
      icon: <VerifiedIcon sx={{ fontSize: 40 }} />,
      color: theme.palette.primary.main,
      criteria: ["مجوز رسمی", "پروانه ساخت", "بیمه نامه معتبر"],
    },
    {
      _id: 2,
      title: "کیفیت تجهیزات و امکانات",
      description:
        "بررسی استانداردهای تجهیزات، بهداشت و ایمنی باشگاه توسط کارشناسان",
      icon: <SecurityIcon sx={{ fontSize: 40 }} />,
      color: theme.palette.success.main,
      criteria: ["تجهیزات استاندارد", "سیستم تهویه", "کادر مجرب"],
    },
    {
      _id: 3,
      title: "پشتیبانی و خدمات",
      description: "ارائه خدمات رزرو آنلاین، پشتیبانی ۲۴ ساعته و ضمانت کیفیت",
      icon: <SupportAgentIcon sx={{ fontSize: 40 }} />,
      color: theme.palette.info.main,
      criteria: ["پشتیبانی آنلاین", "ضمانت بازگشت وجه", "رزرو آسان"],
    },
  ];

  const items = partnershipCriteria.map((item) => (
    <Card
      key={item._id}
      elevation={0}
      sx={{
        flex: 1,
        borderRadius: 4,
        border: `1px solid ${theme.palette.divider}`,
        transition: "all 0.3s ease",
        "&:hover": {
          transform: "translateY(-8px)",
          boxShadow: theme.shadows[8],
          borderColor: item.color,
        },
      }}
    >
      <CardContent sx={{ p: 3, textAlign: "center" }}>
        {/* Icon */}
        <Box
          sx={{
            width: 70,
            height: 70,
            borderRadius: "50%",
            bgcolor: `${item.color}15`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 2,
            color: item.color,
          }}
        >
          {item.icon}
        </Box>

        {/* Title */}
        <Typography
          //   variant="h6"
          sx={{
            fontWeight: 700,
            mb: 1,
            color: "text.primary",
          }}
        >
          {item.title}
        </Typography>

        {/* Description */}
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 2, lineHeight: 1.6, fontSize: ".8rem" }}
        >
          {item.description}
        </Typography>

        {/* Criteria chips */}
        <Stack direction="row" flexWrap="wrap" justifyContent="center" gap={1}>
          {item.criteria.map((criterion, idx) => (
            <Chip
              key={idx}
              label={criterion}
              size="small"
              sx={{
                bgcolor: `${item.color}10`,
                color: item.color,
                fontWeight: 500,
                fontSize: "0.7rem",
                border: `1px solid ${item.color}30`,
              }}
            />
          ))}
        </Stack>
      </CardContent>
    </Card>
  ));
  return (
    <Box
      sx={{
        width: "100%",
        pt: { xs: 4, md: 6 },
        bgcolor: "background.default",
      }}
    >
      <Container maxWidth="xl">
        {/* Header section */}
        <Box sx={{ textAlign: "center", mb: 5 }}>
          <Typography
            // variant="h6"
            sx={{
              fontWeight: 800,
              background: `linear-gradient(45deg, ${theme.palette.primary.main} 30%, ${theme.palette.primary.light} 90%)`,
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              mb: 1,
            }}
          >
            مبنای همکاری ما با باشگاه‌ها
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ maxWidth: 600, mx: "auto" }}
          >
            ما باشگاه‌های برتر را بر اساس استانداردهای زیر انتخاب و با آنها
            همکاری می‌کنیم
          </Typography>
        </Box>

        {/* Cards section */}
        <Stack
          direction={{ xs: "column", md: "row" }}
          justifyContent="center"
          alignItems="stretch"
          sx={{ gap: "16px" }}
        >
          {items}
        </Stack>

        {/* Bottom note */}
        <Paper
          elevation={0}
          sx={{
            mt: 5,
            p: 2,
            borderRadius: 3,
            bgcolor: `${theme.palette.primary.main}08`,
            border: `1px solid ${theme.palette.primary.main}20`,
            textAlign: "center",
          }}
        >
          <Typography variant="caption" color="text.secondary">
            🔹 تمامی باشگاه‌های همکار ما به صورت دوره‌ای مورد بازرسی و ارزیابی
            مجدد قرار می‌گیرند
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}
